import startCase from "lodash/startCase"
import { Column } from "../components/Table"
import {
  reportingCategoriesAndStandardsFormatter,
  shownSkillsFormatter,
  standardTreeNamesFormatter
} from "./tables/content"
import { FILTER_OPTIONS } from "../constants/filters"
import { formatMilliseconds } from "./tables"
import { generateStandardColumn } from "./generateCommonColumns"

export const generateContentLibraryColumns = (
  standardFrameworks: string[],
  categoryFrameworks: string[]
): Column[] => {
  const columns: Column[] = [
    {
      label: "Name",
      name: "content_view_list.name",
      sortable: true,
      description: "content_view_list.description"
    },
    {
      label: "Test",
      name: "content_view_list.test",
      sortable: true
    },
    {
      label: "Type",
      name: "content_view_list.type",
      sortable: true,
      filter: filters => filters.contentType?.length !== 1,
      formatter: (record: any, prop: string) =>
        FILTER_OPTIONS.contentType.find(option => option.value === record[prop])
          ?.label ?? startCase(record[prop])
    }
  ]

  // Add Standards grouped column (for collapsible dropdown in settings)
  const standardColumns = generateStandardColumn(standardFrameworks)
  if (standardColumns) {
    columns.push(standardColumns)
  }

  // Add Categories grouped column (for collapsible dropdown in settings)
  // Child columns have full "Reporting Categories: X" labels for table display
  // Uses accessorPath for nested data access (no flattening needed)
  if (categoryFrameworks.length > 0) {
    columns.push({
      label: "Reporting Categories",
      name: "categories-group",
      columns: categoryFrameworks.map(framework => ({
        label: framework, // Just "ACT", "STAAR" etc. for dropdown
        displayLabel: `Reporting Categories: ${framework}`, // Full label for table header
        name: `categories${framework}`,
        accessorPath: ["content_view_list.nodeNames", framework], // Nested path
        sortable: false,
        formatter: reportingCategoriesAndStandardsFormatter
      }))
    })
  }

  columns.push(
    {
      label: "Skills",
      name: "shownSkills",
      sortable: false,
      formatter: shownSkillsFormatter("remainingSkills")
    },
    {
      label: "Duration",
      name: "content_view_list.duration",
      sortable: true,
      type: "duration",
      align: "right"
    }
  )

  return columns
}

export const generateMasteryLessonContentColumns = (
  standardFrameworks: string[]
): Column[] => {
  const ML_PREFIX = "content_view_ml_lessons"

  const columns: Column[] = [
    {
      label: "Name",
      name: `${ML_PREFIX}.name`,
      sortable: true,
      description: `${ML_PREFIX}.description`
    },
    {
      label: "Test",
      name: `${ML_PREFIX}.test`,
      sortable: true
    }
  ]

  const standardColumns = generateStandardColumn(standardFrameworks)
  if (standardColumns) {
    columns.push(standardColumns)
  }

  columns.push(
    {
      label: "Reporting Category",
      name: `${ML_PREFIX}.nodeNames`,
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Skills",
      name: "shownSkills",
      sortable: false,
      formatter: shownSkillsFormatter("remainingSkills")
    },
    {
      label: "Duration",
      name: `${ML_PREFIX}.duration`,
      sortable: true,
      type: "duration",
      align: "right"
    }
    /*
    {
      label: "Average Time Spent",
      name: `${ML_PREFIX}.averageTimeSpent`,
      sortable: true,
      formatter: formatMilliseconds,
      type: "duration",
      align: "right"
    },
    {
      label: "Average Accuracy",
      name: `${ML_PREFIX}.accuracy`,
      sortable: true,
      type: "percent",
      formatter: (record: any, prop: string) =>
        Number(record[`${ML_PREFIX}.attempts`])
          ? Math.round(record[prop])
          : "--",
      align: "right"
    }
    */
  )

  return columns
}

export const generateElementContentColumns = (
  standardFrameworks: string[]
): Column[] => {
  const ML_PREFIX = "content_view_br_lessons"

  const columns: Column[] = [
    {
      label: "Name",
      name: `${ML_PREFIX}.name`,
      sortable: true,
      description: `${ML_PREFIX}.description`
    },
    {
      label: "Test",
      name: `${ML_PREFIX}.test`,
      sortable: true
    }
  ]

  const standardColumns = generateStandardColumn(standardFrameworks)
  if (standardColumns) {
    columns.push(standardColumns)
  }

  columns.push(
    {
      label: "Reporting Category",
      name: `${ML_PREFIX}.nodeNames`,
      sortable: true,
      formatter: reportingCategoriesAndStandardsFormatter
    },
    {
      label: "Skills",
      name: "shownSkills",
      sortable: false,
      formatter: shownSkillsFormatter("remainingSkills")
    },
    {
      label: "Duration",
      name: `${ML_PREFIX}.duration`,
      // sortable: true,
      type: "duration",
      //formatter: (_record, _prop) => {
      //  // Non-breaking space - looks empty but bypasses the "|| --" fallback
      //  return "\u00A0"
      //},
      align: "right"
    }
    // {
    //   label: "% Complete",
    //   name: "content_view_br_lessons.completedPercent",
    //   sortable: true,
    //   type: "percent",
    //   align: "right"
    // },
    /*
    {
      label: "Average Time Spent",
      name: `${ML_PREFIX}.averageTimeSpent`,
      // sortable: true,
      // type: "duration",
      formatter: (record, prop) => {
        // Non-breaking space - looks empty but bypasses the "|| --" fallback
        return "\u00A0"
      },
      align: "right"
    }
    */
  )

  return columns
}
